# @author: thallada

$ = require('jquery')
_ = require('underscore')
base64 = require('js-base64')
kloggyr_pkg = require('../package.json')

# Shim for Date's toISOString() which is not supported in IE8
# From Mozilla:
# https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toISOString#Polyfill
`
if (!Date.prototype.toISOString) {
  (function() {

    function pad(number) {
      if (number < 10) {
        return '0' + number;
      }
      return number;
    }

    Date.prototype.toISOString = function() {
      return this.getUTCFullYear() +
        '-' + pad(this.getUTCMonth() + 1) +
        '-' + pad(this.getUTCDate()) +
        'T' + pad(this.getUTCHours()) +
        ':' + pad(this.getUTCMinutes()) +
        ':' + pad(this.getUTCSeconds()) +
        '.' + (this.getUTCMilliseconds() / 1000).toFixed(3).slice(2, 5) +
        'Z';
    };

  }());
}
`

# Shim for the Window.location.origin variable which is not supported in IE8
# From Toby Osbourn:
# http://tosbourn.com/a-fix-for-window-location-origin-in-internet-explorer/
`
if (!window.location.origin) {
  window.location.origin = window.location.protocol + "//" + window.location.hostname +
                           (window.location.port ? ':' + window.location.port: '');
}
`

ONE_MILLION = 1000000

class Kloggyr
  @SERVICE_URLS = {
    'LCL': 'http://localhost:5000/'
    'DEV': 'https://dev-kloggyr-service.kyruus.com/'
    'STG': 'https://stg-kloggyr-service.kyruus.com/'
    'PRD': 'https://kloggyr-service.kyruus.com/'
  }
  @DEPLOYMENT_NAMES = {
    'LCL': 'LCL'
    'DEV': 'DEV'
    'STG': 'STG'
    'PRD': 'PRD'
    # allowable alternate names
    'LOCAL': 'LCL'
    'DEVELOPMENT': 'DEV'
    'DEVELOP': 'DEV'
    'STAGING': 'STG'
    'STAGE': 'STG'
    'PRODUCTION': 'PRD'
    'PROD': 'PRD'
  }

  constructor: (@name, @context) ->
    if not @context then @context = {}
    if 'deployment' of @context
      Kloggyr.set_env(@context)

  _encode_log: (log) ->
    base64.Base64.encodeURI(log)

  _send_log: (log, deferred) ->
    encoded_log = @_encode_log(log)
    $track_img = $("<img src= " + Kloggyr.logging_config.kloggyr_service_url + 'api/log?data=' + encoded_log + ">")
    $track_img.attr("alt", "")
    $track_img.attr("aria-hidden", "true")
    $track_img.css("position", "absolute")
    $track_img.css("top", "-1000px")
    $track_img.css("left", "-1000px")
    $track_img.css("z-index", "-999999")
    $("body").append($track_img)

  _is_log_over_threshold: (level) ->
    if not level
      throw Error("Level is #{level}, must be one of DEBUG, INFO, WARNING, ERROR, or CRITICAL")
    level_order = ['DEBUG', 'INFO', 'WARNING', 'ERROR', 'CRITICAL']
    threshold = level_order.indexOf(Kloggyr.logging_config.logging_level.toUpperCase())
    log_lvl = level_order.indexOf(level.toUpperCase())
    if log_lvl is -1
      throw Error("Level is #{level}, must be one of DEBUG, INFO, WARNING, ERROR, or CRITICAL")
    return log_lvl >= threshold

  log: (options) ->
    if @_is_log_over_threshold(options.level)
      log =
        level: options.level,
        message: options.message,
        event_name: options.event_name,
        event_data: options.event_data,
        event_time: new Date().toISOString(),
        name: @name,
        user_metadata: {
          screen_width: screen.width,
          screen_height: screen.height
        },
        kloggyr_js_version: kloggyr_pkg.version,
        no_cache_key: Math.random() * ONE_MILLION
      log = $.extend({}, @context, log)
      if options.event_data and 'tracking_token' of options.event_data
        log.tracking_token = options.event_data.tracking_token
        delete options.event_data.tracking_token
      log_string = Kloggyr.logging_config.handler(log)
      @_send_log(log_string, options.deferred)

  debug: (options) ->
    return @log($.extend(options, {level: 'DEBUG'}))

  info: (options) ->
    return @log($.extend(options, {level: 'INFO'}))

  warning: (options) ->
    return @log($.extend(options, {level: 'WARNING'}))

  error: (options) ->
    return @log($.extend(options, {level: 'ERROR'}))

  critical: (options) ->
    return @log($.extend(options, {level: 'CRITICAL'}))

  @json_logging_handler = (log_obj) ->
    return JSON.stringify(log_obj)

  @plain_logging_handler = (log_obj) ->
    log_str = ''
    elem_order = ['event_time', 'name', 'level', 'message', 'user_id', 'customer_id', 'session_id', 'request_id',
                  'tracking_token', 'event_name', 'event_data']
    for elem in elem_order
      if log_obj[elem] then log_str +=
        (if typeof log_obj[elem] == 'object' then JSON.stringify(log_obj[elem]) else log_obj[elem]) + '\t'
    log_str = log_str.slice(0, -1) if log_str # chop off last tab char
    return log_str

  @logging_config =
    logging_level: 'INFO',
    contentType: 'text/plain',
    handler: Kloggyr.json_logging_handler,
    kloggyr_service_url: Kloggyr.SERVICE_URLS['DEV'],
    timeout: 300

  _formats = {
    plain: {
      handler: Kloggyr.plain_logging_handler,
    }
    json: {
      handler: Kloggyr.json_logging_handler,
    }
  }

  @log_in = (format) ->
    if format of _formats
      Kloggyr.logging_config.handler = _formats[format].handler
      Kloggyr.logging_config.contentType = _formats[format].contentType
    else
      throw new Error("Format #{format} is not a supported format in Kloggyr")

  @set_env = (context) ->
    normalized_deployment_name = Kloggyr.DEPLOYMENT_NAMES[context.deployment.toUpperCase()]
    if normalized_deployment_name of Kloggyr.SERVICE_URLS
      Kloggyr.logging_config.kloggyr_service_url = Kloggyr.SERVICE_URLS[normalized_deployment_name]
    else
      throw new Error("Deployment name: #{context.deployment} is not a supported deployment name in Kloggyr")


module.exports = Kloggyr
